
export function getDate() {
  let nowDate = new Date();
  let date = {
      year: nowDate.getFullYear(),
      month: nowDate.getMonth() + 1 < 10 ?  '0' + (nowDate.getMonth() + 1): nowDate.getMonth() + 1,
      date: nowDate.getDate() < 10 ?  '0' + nowDate.getDate() : nowDate.getDate(),
      hours : nowDate.getHours(),
      minutes : nowDate.getMinutes() < 10 ? '0' + nowDate.getMinutes() : nowDate.getMinutes(),
      seconds : nowDate.getSeconds() < 10 ? '0' + nowDate.getSeconds() : nowDate.getSeconds()
  }
  let systemDate = date.year  + date.month + date.date;
  return {date,systemDate}
}

export function formatConversion(val,flag){
  if(val == ''){
		return '';
	}
	if(val.length == 8){
		val = '00' + val
	}
	if(val.length == 9){
		val = '0' + val
	}
	if(val.length === 13){
		var time = new Date(val); //时间戳为10位需*1000，时间戳为13位的话不需乘1000
		var y = time.getFullYear();
		var m = time.getMonth() < 9 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1;
		var d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
		var h = time.getHours() < 10 ? '0' + time.getHours() : time.getHours();
		var mm = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes();
		var s = time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds();
		var timedate = y + '-' + m + '-' + d + ' ' + h + ':' + mm;
		return timedate;
	}else if(val.length === 10){
		if(flag){
			var time = new Date(val * 1000);
			var y = time.getFullYear();
			var m = time.getMonth() < 9 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1;
			var d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
			var h = time.getHours() < 10 ? '0' + time.getHours() : time.getHours();
			var mm = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes();
			var s = time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds();
			var timedate = y + '-' + m + '-' + d + ' ' + h + ':' + mm + ':' + s;
			return timedate;
		}else{
			var time = new Date(val * 1000);
			var y = time.getFullYear();
			var m = time.getMonth() < 9 ? '0' + (time.getMonth() + 1) : time.getMonth() + 1;
			var d = time.getDate() < 10 ? '0' + time.getDate() : time.getDate();
			var h = time.getHours() < 10 ? '0' + time.getHours() : time.getHours();
			var mm = time.getMinutes() < 10 ? '0' + time.getMinutes() : time.getMinutes();
			var s = time.getSeconds() < 10 ? '0' + time.getSeconds() : time.getSeconds();
			var timedate = y + '-' + m + '-' + d + ' ' + h + ':' + mm;
			return timedate;
		}
		
  }
}